import { Divider } from 'antd';
import { FC, useMemo, useContext } from 'react';

import { Grid, Image } from '@/shared/ui';

import { imageBase64 } from '@/helpers/fileHelper';

import { RmpcTattooDetailed } from '@/api/integrations/rmpc/types/types';

import { TattooSearchContext } from '../../../context/TattooSearchContext';

import { RelatedTattoosList } from '../RelatedTattoosList';
import { TattooRecognitionInfo } from '../TattooRecognitionInfo';
import { buildGridData } from '../utils/buildGridData';

interface TattooDetailsContentProps {
  tattooData: RmpcTattooDetailed;
}

export const TattooDetailsContent: FC<TattooDetailsContentProps> = ({ tattooData }) => {
  const { categories, bodyLocations } = useContext(TattooSearchContext);

  const gridData = useMemo<Array<[string, Nullable<string>]>>(() => {
    return buildGridData(tattooData, categories || [], bodyLocations || []);
  }, [tattooData, categories, bodyLocations]);

  const related = tattooData.related || [];

  return (
    <>
      {tattooData.image && (
        <div className="tattoo-details__modal-image">
          <Image src={imageBase64(tattooData.image)} alt={`Татуювання ${tattooData.number}`} />
        </div>
      )}
      <Grid data={gridData} />
      {related.length > 0 && (
        <>
          <Divider />
          <RelatedTattoosList related={related} />
        </>
      )}
      <Divider />
      <TattooRecognitionInfo />
    </>
  );
};
